const SETCOUNTSOLICITATION = (state, total) => {
  state.totalSolicitacoes = total
}

const SETSOLICITACOES = (state, list) => {
  state.solicitacoes = list
}

const SETSTATUSFILTER = (state, filter) => {
  state.filter = filter
}

const SETSTATUS = (state, status) => {
  state.status = status
}

const SETFILES = (state, files) => {
  state.files = files
}

const SETHISTORICS = (state, list) => {
  state.historics = list
}

const SETREASONS = (state, list) => {
  state.reasons = list
}

const SETEMPREENDIMENTOS = (state, list) => {
  state.empreendimentos = list
}

const SETEMPREENDIMENTOSUSER = (state, list) => {
  state.empreendimentosUser = list
}

const SETSERVICES = (state, list) => {
  state.services = list
}

const SETCLICKED = (state, item) => {
  state.clicked = item
}

const SETPAGINATION = (state, obj) => {
  obj.pageNumber = obj.pageNumber === 0 ? 1 : obj.pageNumber
  state.pagination = obj
}

const SETALTCANCPAGINATION = (state, obj) => {
  obj.pageNumber = obj.pageNumber === 0 ? 1 : obj.pageNumber
  state.altCancPagination = obj
}

const SETSHOWDEADLINE = (state, obj) => {
  state.showDeadline = obj
}

const SETNUMEROIDDIRETRIZ = (state, obj) => {
  state.numeroIdDiretriz = obj
}

const SETADDRESSHISTORIC = (state, obj) => {
  state.addressHistoric = obj
}

const SETFILESHASCHANGES = (state, info) => {
  state.filesHasChanges = info
}

const SETALTCANCELAPROVEGRANT = (state, info) => {
  state.hasAltCancelAproveGrant = info
}

const SETPENDINGALTCANCELLIST = (state, list) => {
  state.pendingAltCancelHists = list
}

const SETPENDINGALTCANCCOMMENTDETAILS = (state, obj) => {
  state.pendingAltCancCommentDetails = obj
}

const SETISPENDINGREQUESTALTCANC = (state, info) => {
  state.isPendingRequestAltCanc = info
}

export default {
  SETSOLICITACOES,
  SETSTATUSFILTER,
  SETFILES,
  SETHISTORICS,
  SETREASONS,
  SETEMPREENDIMENTOS,
  SETEMPREENDIMENTOSUSER,
  SETSERVICES,
  SETCOUNTSOLICITATION,
  SETSTATUS,
  SETCLICKED,
  SETPAGINATION,
  SETSHOWDEADLINE,
  SETNUMEROIDDIRETRIZ,
  SETADDRESSHISTORIC,
  SETFILESHASCHANGES,
  SETALTCANCELAPROVEGRANT,
  SETPENDINGALTCANCELLIST,
  SETPENDINGALTCANCCOMMENTDETAILS,
  SETALTCANCPAGINATION,
  SETISPENDINGREQUESTALTCANC
}
